module.exports = __webpack_public_path__ + "img/treemap.d9ff4439.svg";